import {
	Component,
	Input,
	OnInit,
} from '@angular/core';


import { PopUpService } from 'ib/internetbank-core/ib-components/pop-ups/pop-up/pop-up.service';
import { Base64 } from 'ib/internetbank-core/ib-models/common-types';

import { AppealDocument } from '../../../../../../../sections/statements-section/statements-model';
import { PdfViewerContentComponentForPopupComponentComponent } from '../../../../../../../shared/components/pdf-viewer.content-component-for-popup-component/pdf-viewer.content-component-for-popup-component';

@Component({
	selector: 'app-appeal-document',
	templateUrl: './appeal-document.component.html',
	styleUrls: ['./appeal-document.component.less'],
})
export class AppealDocumentComponent implements OnInit {


	@Input()
	public document: AppealDocument;

	constructor(
		private popUpService: PopUpService,
	) { }

	public ngOnInit(): void {
	}

	public async open(e: Event) {

		e.preventDefault();
		e.stopImmediatePropagation();

		this.popUpService.open(
			PdfViewerContentComponentForPopupComponentComponent,
			{
				inputs: {
					title: this.document.fileName,
					base64Src: this.document.file,
					shareData: {
						text: this.document.fileName,
						title: this.document.fileName,
						// url: this.document.file,
						files: [
							await this.base64ToFileAsync(
								this.document.file,
								this.document.fileName.toLowerCase().endsWith('.pdf')
									? this.document.fileName
									: (this.document.fileName + '.pdf')),
						],
					},
				},
			},
		)
	}

	public async base64ToFileAsync(base64: Base64, filename: string): Promise<File> {
		const base64WithoutPrefix = base64.includes(',')
			? base64.split(',')[1]
			: base64;
		const response = await fetch(`data:application/pdf;base64,${base64WithoutPrefix}`);
		const blob = await response.blob();
		const file = new File([blob], filename, { type: 'application/pdf' });
		return file;
	}

}
